import React from 'react';
import play from '../../../assets/icons/play.svg';
import titleborder from '../../../assets/icons/title_border.svg';
// import SampleVideo from '../../../assets/videos/sample.mp4';

const IntroSection = ({ themeData }: any) => {
  return (
    <>
      <section className="intro-section">
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <div className="section-card">
                <div className="section-title">
                  <p
                    style={{
                      color: `#${themeData?.theme_2?.home?.section_2?.h3color}`,
                    }}
                  >
                    {themeData?.theme_2?.home?.section_2?.sub_heading_top}
                  </p>
                  <h2
                    style={{
                      color: `#${themeData?.theme_2?.home?.section_2?.h2color}`,
                    }}
                  >
                    {themeData?.theme_2?.home?.section_2?.title}
                  </h2>
                  <img src={titleborder} alt="" />
                </div>
                <div className="intro-content">
                  <div className="intro-img">
                    <img
                      src={themeData?.theme_2?.home?.section_2?.banner}
                      alt=""
                    />
                  </div>
                  <div className="gr-border">
                    <div className="gr-border-grid intro-data-box">
                      <ul>
                        {themeData?.theme_2?.home?.section_2?.card_section_one?.map(
                          (items: any) => {
                            return (
                              <>
                                <li>
                                  <h3 style={{
                                    color: `#${themeData?.theme_2?.home?.section_2?.h3color}`
                                  }}>{items.count}</h3>
                                  <p
                                    style={{
                                      color: `#${themeData?.theme_2?.home?.section_2?.h3color}`,
                                    }}
                                  >
                                    {items.text}
                                  </p>
                                </li>
                              </>
                            );
                          }
                        )}
                      </ul>
                    </div>
                  </div>
                  <p
                    className="intro-desc"
                    style={{
                      color: `#${themeData?.theme_2?.home?.section_2?.paracolor}`,
                    }}
                  >
                    {themeData?.theme_2?.home?.section_2?.mainparagraph}
                  </p>
                  <div className="intro-content-btn d-none">
                    <a
                      className="btn"
                      href="javascript:void(0)"
                      data-bs-toggle="modal"
                      data-bs-target="#videomodal"
                    >
                      <img src={play} alt="" />
                    </a>
                    <p>
                      Click on this video to check how we work with Our Clients
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="section-card intro-right-grid">
                <div className="review-grid text-center">
                  <h2
                    style={{
                      color: `#${themeData?.theme_2?.home?.section_2?.h2color}`,
                    }}
                  >
                    {themeData?.theme_2?.home?.section_2?.card_section_title}
                  </h2>
                  <div className="review-stars">
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                  </div>
                  <p
                    style={{
                      color: `#${themeData?.theme_2?.home?.section_2?.paracolor}`,
                    }}
                  >
                    {themeData?.theme_2?.home?.section_2?.rating}{' '}
                    {themeData?.theme_2?.home?.section_2?.card_sub_text}
                  </p>
                </div>
                {themeData?.theme_2?.home?.section_2?.card_section_two.map(
                  (item: any) => {
                    return (
                      <>
                        <div className="gr-border">
                          <div className="gr-border-grid intro-points-box">
                            <img src={item.card_icon} alt="" />
                            <p
                              style={{
                                color: `#${themeData?.theme_2?.home?.section_2?.paracolor}`,
                              }}
                            >
                              {item.card_sub_heading_top}
                            </p>
                            <h5
                              style={{
                                color: `#${themeData?.theme_2?.home?.section_2?.h3color}`,
                              }}
                            >
                              {item.card_title}
                            </h5>
                            <p
                              style={{
                                color: `#${themeData?.theme_2?.home?.section_2?.paracolor}`,
                              }}
                            >
                              {item.card_paragraph}
                            </p>
                          </div>
                        </div>
                      </>
                    );
                  }
                )}
              </div>
            </div>
          </div>
        </div>
        {/* <div
          className="modal fade"
          id="videomodal"
          aria-hidden="true"
          data-bs-keyboard="false"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content modal-video">
              <video width="100%" height="auto" autoPlay loop muted>
                <source src={SampleVideo} type="video/mp4" />
              </video>
            </div>
          </div>
        </div> */}
      </section>
    </>
  );
};

export default IntroSection;
